import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalGroupList extends BaseModelAPI {

	static entity = 'approvalgrouplist'
	static entityName = 'approvalgroup';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
